import React from 'react';
import Navbar from '../../components/Items/Navbar';
import BackNav from '../../components/navigation/BackNav';
import AdaptiveQuickNav from './AdaptiveQuickNav';
import '../../pages/learn/learn.css';
import '../../pages/adaptive/adaptive.css';

export default function AdaptivePageShell({
  userProfile,
  loading = false,
  backTo = '/dashboard',
  backLabel = 'Study hub',
  children,
  showQuickNav = true,
  className = '',
}) {
  return (
    <div className="learn-app-shell">
      <Navbar userProfile={userProfile} loading={loading} />
      <div className={`app-page-shell home-page-shell home-page-shell--minimal adaptive-shell ${className}`.trim()}>
        <BackNav to={backTo} label={backLabel} />
        <div className="adaptive-page">{children}</div>
        {showQuickNav && <AdaptiveQuickNav />}
      </div>
    </div>
  );
}
